import React from "react";
import {ListItem, SectionHeading} from "../PromotionsText";

const ParticipationSection = () => (
  <>
    <SectionHeading>Participation in Promotions</SectionHeading>

    <ListItem marker="(a)">{"Participation in any Promotion may be automatic or voluntary."}</ListItem>

    <ListItem marker="(b)">
      {"Where participation in a Promotion is not automatic, You should follow the instructions set out in the relevant Promotion Communication, on the individual web landing page for that Promotion and, where appropriate, the applicable Key Terms."}
    </ListItem>

    <ListItem marker="(c)" withBottomMargin>
      {"Unless otherwise indicated in the applicable Key Terms, entry into each Promotion may be used only once."}
    </ListItem>
  </>
);

export default ParticipationSection;
